"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var REDIRECT_BANNER_API = "/api/redirect-banner";
var REDIRECT_BANNER_V1_API = "/api/redirect-banner/v1";
var RedirectBannerAPIConsumer = (function () {
    function RedirectBannerAPIConsumer(props) {
        this.urlParams = "";
        this.connectUrl = "";
        this.props = props;
        this.randomNumber = Math.floor(Math.random() * Math.pow(10, 13));
        this.params = new RedirectBannerParams(this.props, this.randomNumber);
        this.urlParams = this.buildURLParams(this.params);
        var domainOverride = this.props.domainOverride;
        this.connectUrl = "";
        if (domainOverride) {
            this.connectUrl = domainOverride;
        }
    }
    RedirectBannerAPIConsumer.prototype.fetchRedirectBannerData = function () {
        return utils_1.get(this.connectUrl.concat(REDIRECT_BANNER_API, this.urlParams));
    };
    RedirectBannerAPIConsumer.prototype.fetchRedirectBannerDataV1 = function () {
        return utils_1.get(this.connectUrl.concat(REDIRECT_BANNER_V1_API, this.urlParams));
    };
    RedirectBannerAPIConsumer.prototype.buildURLParams = function (params) {
        return "?" + this.jsonToUrlParam(params);
    };
    RedirectBannerAPIConsumer.prototype.jsonToUrlParam = function (params) {
        return Object.keys(params)
            .filter(function (key) { return !!params[key]; })
            .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]); })
            .join("&");
    };
    return RedirectBannerAPIConsumer;
}());
exports.RedirectBannerAPIConsumer = RedirectBannerAPIConsumer;
var RedirectBannerParams = (function () {
    function RedirectBannerParams(props, randomNumber) {
        this.siteid = props.siteid;
        this.locale = props.locale;
        this.langid = props.langid;
        this.countryCode = props.countryCode;
        this.spoofLocation = props.spoofLocation;
        this._ = randomNumber;
    }
    return RedirectBannerParams;
}());
exports.RedirectBannerParams = RedirectBannerParams;
//# sourceMappingURL=redirect-banner-api-consumer.js.map